import { HttpClient } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { DataService } from "src/app/shared/Services/data.service";
import { GetCurrentShift } from "src/app/shared/Services/getCurrentShift";
import { takeUntil } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";
import * as moment from "moment";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import pdfMake from "pdfmake/build/pdfMake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: "app-energy-dashboard",
  templateUrl: "./energy-dashboard.component.html",
  styleUrls: ["./energy-dashboard.component.scss"],
})
export class EnergyDashboardComponent implements OnInit, OnDestroy {
  private cancelPreviousRequests$ = new Subject<void>();
  currentTime: any;
  breadCrumbItems: Array<{}>;
  user: any;
  role: string = "";
  timeZone: string = "";
  custId: string = "";
  customerList: any = [];
  selectedCustomerId: any;
  filteredData: any = [];
  departmentData: any = [];
  selectedDepartment: any;
  selectedDepartmentShift: any = [];
  departmentcurrentShiftData: any;
  custList: any = [];
  selectedShift: string = "";
  maxdate: any;
  mindate: any;
  fromDate: any;
  energyData: any = {};
  pdfBool: boolean = false;
  csvBool: boolean = false;
  mailform: FormGroup;
  base64String;
  action: any;
  exportViaMail: boolean = false;
  selectedShiftId: string = "";
  machineData: any = [];
  filterMachine: any = [];
  selectedMachine: any = "";
  selectedMachineId: any = "";
  energyChartOption: any;
  voltageChartOption: any;
  analogChartOption: any;
  powerfactorChartOption: any;
  currentChartOption: any;
  livebool: boolean = true;
  tableDataKeys: any;
  itemsPerPage = 5;
  pageSize;
  currentPage = 1;
  custName: any = ''
  subscriptions: Subscription[] = [];
  constructor(
    private http: HttpClient,
    public formBuilder: FormBuilder,
    private dataService: DataService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private currShift: GetCurrentShift
  ) {
    this.user = JSON.parse(sessionStorage.getItem("currentUser"));
    this.role = this.user["user"]["role"];
  }

  ngOnInit(): void {
    this.currentTime = moment().format('HH:mm:ss')
    this.mailform = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });
    this.convertImageToBase64();

    if (this.role == "SUPERADMIN") {
      this.timeZone = sessionStorage.getItem("Selected_CustomerTimeZone");
      this.custId = sessionStorage.getItem("Selected_CustomerID");
      this.custName = sessionStorage.getItem('Selected_CustomerName');
      if (this.custId) {
        this.getUser();
        this.getDepartment(this.custId);
      } else {
        this.getUser();
      }
    } else if (this.role == "CUSTOMER" || this.role == "SUPERVISOR") {
      this.breadCrumbItems = [
        { label: "K2" },
        { label: "Energy Dashboard", active: true },
      ];
      this.timeZone = this.user.user.timeZone;
      this.custId = this.user["user"]["custId"];
      this.custName = this.user["user"]["name"];
      this.getDepartment(this.custId);
      this.auditLogs()
    }
  }
  auditLogs() {
    let obj = {
      custID: this.custId
    }
    const subscription = this.dataService
      .reportApi(
        "auditlog/energy",
        obj
      )
      .subscribe(
        (res) => {

        },
        (error) => {
          this.toastr.error("Server Unreachable", error);
        }
      );
    this.subscriptions.push(subscription);
  }
  convertImageToBase64() {
    const imagePath = "assets/wimera/Wimera_Logo_wSlogan_Green.png";
    this.http.get(imagePath, { responseType: "blob" }).subscribe(
      (data: Blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.base64String = reader.result as string;
        };
        reader.readAsDataURL(data);
      },
      (error) => {
        console.error("Error loading the image:", error);
      }
    );
  }

  getDepartment(custId) {
    this.departmentData = [];
    this.dataService.get(`department?custId=${custId}`).subscribe(
      (res: any) => {
        if (res) {
          this.departmentData = res["data"];
          this.selectedDepartment = this.departmentData[0]["departmentName"];
          this.selectedDepartmentShift = this.departmentData[0]["shiftData"];
          this.departmentcurrentShiftData = this.currShift.getCurrentShift(
            this.selectedDepartmentShift,
            this.timeZone
          );
          if (this.departmentcurrentShiftData != undefined) {
            this.fromDate = moment(
              this.departmentcurrentShiftData.currentDate
            ).format("YYYY-MM-DD");
            this.maxdate = this.fromDate;
            this.selectedShift = this.departmentcurrentShiftData.shiftName;
            this.selectedShiftId =
              this.departmentcurrentShiftData["usershiftId"];
            this.getMachines();
          }
        }
      },
      (error) => {
        this.toastr.error("Server Unreachable", error.error);
      }
    );
  }
  getMachines() {
    this.machineData = [];
    this.filterMachine = [];
    this.dataService
      .get(`api/device?custId=${this.custId}`)
      .subscribe((res) => {
        if (res) {
          this.machineData = res;
          this.machineData = this.machineData.filter((val) => val.meterSupplier == 'Wimera-K2' || val.meterSupplier == 'K2-V1.1')

          this.filterMachine = this.machineData.filter(
            (val) => val.departmentName === this.selectedDepartment
          );
          if (this.filterMachine.length) {
            this.selectedMachine = this.filterMachine[0]["deviceName"];
            this.selectedMachineId = this.filterMachine[0]["deviceId"];
            this.getenergyData();
          }
        }
      });
  }

  select_Department(data: any) {
    this.selectedDepartment = data;

    const filter = this.departmentData.filter(
      (val) => val.departmentName === data
    );

    this.selectedDepartmentShift = filter[0]["shiftData"];
    this.departmentcurrentShiftData = this.currShift.getCurrentShift(
      this.selectedDepartmentShift,
      this.timeZone
    );
    if (
      this.departmentcurrentShiftData &&
      this.departmentcurrentShiftData.currentDate
    ) {
      const today = moment(this.departmentcurrentShiftData.currentDate).format(
        "YYYY-MM-DD"
      );
      this.maxdate = today;
      this.fromDate = today;
      this.selectedShift = this.departmentcurrentShiftData.shiftName;
      this.selectedShiftId = this.departmentcurrentShiftData["usershiftId"];
      this.getMachines();
    }
  }

  select_Machine(value) {
    this.selectedMachine = value;
    const filterMachine = this.machineData.filter(
      (val) => val.deviceName === this.selectedMachine
    );
    this.selectedMachineId = filterMachine[0]["deviceId"];

    this.getenergyData();
  }
  select_Shift(data: any) {
    this.selectedShift = data;

    const filtershift = this.selectedDepartmentShift?.filter(
      (val) => val.shiftName === this.selectedShift
    );
    this.selectedShiftId = filtershift[0]["usershiftId"];

    this.getenergyData();
  }
  select_Date(e: any) {
    this.fromDate = e;
    this.getenergyData();
  }

  getUser() {
    this.dataService
      .get("api/user")
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe((res: any) => {
        let response = res;
        this.custList = response.filter((val) => {
          return val.name !== "SUPERADMIN";
        });
        this.validate_customer(this.custList);
      });
  }

  validate_customer(data: any[]): void {
    if (!Array.isArray(data)) return;
    this.customerList = data
      .filter(
        (item) =>
          item?.status &&
          Array.isArray(item.status.deviceDetails) &&
          item.status.deviceDetails.length > 0
      )
      .map((item) => ({
        custName: item.status.customerName,
        custId: item.status.custId,
        deviceList: item.status.deviceDetails,
        timeZone: item.timeZone,
      }));
    let custshiftData = sessionStorage.getItem("Selected_CustomerID");

    if (custshiftData) {
      let selected = this.customerList.filter((val) => {
        return val.custId == custshiftData;
      });
      this.selectedCustomerId = selected[0];
      this.custName = this.selectedCustomerId.custName
    } else {
      this.custId = this.customerList[9]["custId"];
      this.selectedCustomerId = this.customerList[9];
      this.timeZone = this.selectedCustomerId.timeZone
      sessionStorage.setItem(
        "Selected_CustomerName",
        this.selectedCustomerId.custName
      );
      sessionStorage.setItem(
        "Selected_CustomerID",
        this.selectedCustomerId.custId
      );
      sessionStorage.setItem(
        "Selected_CustomerTimeZone",
        this.selectedCustomerId.timeZone
      );
      this.custName = this.selectedCustomerId.custName
      this.getDepartment(this.custId);
    }
  }

  refreshClick() {
    this.getenergyData();
  }

  onChange(custId: any) {
    this.departmentData = [];
    this.selectedDepartment = "";
    sessionStorage.setItem("Selected_CustomerName", custId.custName);
    sessionStorage.setItem("Selected_CustomerID", custId.custId);
    sessionStorage.setItem("Selected_CustomerTimeZone", custId.timeZone);
    this.custId = custId.custId;
    this.timeZone = custId.timeZone;
    this.filteredData = this.customerList.filter(
      (customer) => customer.custId === this.custId
    );
    this.getDepartment(this.custId);
  }
  showenergyload: boolean = true;
  energyDatas: boolean = false;
  chartBool: boolean = true
  getenergyData() {
    this.showenergyload = false
    this.spinner.show();
    this.showenergyload = true
    this.energyData = {};
    if (this.fromDate == moment(this.departmentcurrentShiftData.currentdate).format('YYYY-MM-DD')
      || this.fromDate == moment(this.departmentcurrentShiftData.currentdate).subtract(1, 'day').format('YYYY-MM-DD')
    ) {
      let query = {
        "custId": this.custId,
        "deviceId": this.selectedMachineId,
        "department": this.selectedDepartment,
        "date": this.fromDate,
        "usershiftId": this.selectedShiftId,
        "islive": true
      }
      this.dataService
        .machineApi(
          "energy_metrics",
           query)
        .subscribe(
          (res: any) => {
            if (res) {
              this.energyData = res;
              if (this.fromDate == moment(this.departmentcurrentShiftData.currentdate).subtract(1, 'day').format('YYYY-MM-DD')) {
                this.chartBool = false
              } else {
                this.chartBool = true
              }
              this.livebool = true;
              this.tableDataKeys = Object.keys(this.energyData?.tableData || {}).filter(key => {
                const arr = this.energyData.tableData[key];
                // include only if array exists and has at least one non-null object with a value
                return Array.isArray(arr) && arr.some(item => item && (item.min || item.max || item.avg));
              });
              this.getChart(this.energyData)

              const energyTable = this.energyData.hourlyData;

              const chartsConfig = [
                { unit: "V", key: "voltage", title: "Voltage (V)", series: ["voltageR", "voltageY", "voltageB"] },
                { unit: "A", key: "current", title: "Current (A)", series: ["currentR", "currentY", "currentB"] },
                { unit: "pf", key: "powerfactor", title: "Powerfactor", series: ["powerfactorR", "powerfactorY", "powerfactorB"] },
              ];

              // Loop through each chart
              chartsConfig.forEach(cfg => {
                // Filter only series that have data
                const filteredSeries = cfg.series.filter(seriesKey => {
                  // const actualKey = seriesKey.replace("powerfactor", "powerfactor");
                  return energyTable[seriesKey] && energyTable[seriesKey].length > 0;
                });

                // If no valid data → show “No Data Available”
                if (filteredSeries.length === 0) {
                  this.generateChart(null, cfg.key, cfg.title, cfg.series, cfg.unit);
                } else {
                  // Else → pass data and valid series
                  this.generateChart(this.energyData, cfg.key, cfg.title, filteredSeries, cfg.unit);
                }
              });
              this.spinner.hide();
              this.showenergyload = false
              if (this.energyData && Object.keys(this.energyData).length > 0) {
                this.energyDatas = true
              } else {
                this.energyDatas = false
              }
            } else {
              this.spinner.hide();
              this.showenergyload = false
              this.energyData = {};
              const energyTable = this.energyData.hourlyData;
              const chartsConfig = [
                { unit: "V", key: "voltage", title: "Voltage (V)", series: ["voltageR", "voltageY", "voltageB"] },
                { unit: "A", key: "current", title: "Current (A)", series: ["currentR", "currentY", "currentB"] },
                { unit: "pf", key: "powerfactor", title: "Powerfactor", series: ["powerfactorR", "powerfactorY", "powerfactorB"] },
              ];

              // Loop through each chart
              chartsConfig.forEach(cfg => {
                // Filter only series that have data
                const filteredSeries = cfg.series.filter(seriesKey => {
                  // const actualKey = seriesKey.replace("powerfactor", "powerFactor");
                  return energyTable[seriesKey] && energyTable[seriesKey].length > 0;
                });

                // If no valid data → show “No Data Available”
                if (filteredSeries.length === 0) {
                  this.generateChart(null, cfg.key, cfg.title, cfg.series, cfg.unit);
                } else {
                  // Else → pass data and valid series
                  this.generateChart(this.energyData, cfg.key, cfg.title, filteredSeries, cfg.unit);
                }
              });
              this.getChart(null);
            }
          },
          (error) => {
            console.error('Error fetching energy metrics:', error);
            this.spinner.hide();
            this.showenergyload = false;
            this.energyDatas = false;
            this.energyData = {};
            this.energyData = {};
            const energyTable = this.energyData.hourlyData;
            const chartsConfig = [
              { unit: "V", key: "voltage", title: "Voltage (V)", series: ["voltageR", "voltageY", "voltageB"] },
              { unit: "A", key: "current", title: "Current (A)", series: ["currentR", "currentY", "currentB"] },
              { unit: "pf", key: "powerfactor", title: "Powerfactor", series: ["powerfactorR", "powerfactorY", "powerfactorB"] },
            ];

            // Loop through each chart
            chartsConfig.forEach(cfg => {
              // Filter only series that have data
              const filteredSeries = cfg.series.filter(seriesKey => {
                // const actualKey = seriesKey.replace("powerfactor", "powerFactor");
                return energyTable[seriesKey] && energyTable[seriesKey].length > 0;
              });

              // If no valid data → show “No Data Available”
              if (filteredSeries.length === 0) {
                this.generateChart(null, cfg.key, cfg.title, cfg.series, cfg.unit);
              } else {
                // Else → pass data and valid series
                this.generateChart(this.energyData, cfg.key, cfg.title, filteredSeries, cfg.unit);
              }
            });
            this.getChart(null);

          }
        );
    } else {


      let query = {
        "custId": this.custId,
        "deviceId": this.selectedMachineId,
        "department": this.selectedDepartment,
        "date": this.fromDate,
        "usershiftId": this.selectedShiftId,
        "islive": false
      }
      this.dataService.machineApi("energy_metrics",query)
        .subscribe(
          (res: any) => {
            if (res) {
              console.log(res);
              this.energyData = res;
              this.livebool = false;
              this.chartBool = false;

              console.log(this.energyData);
              this.tableDataKeys = Object.keys(this.energyData?.tableData || {}).filter(key => {
                const arr = this.energyData.tableData[key];
                // include only if array exists and has at least one non-null object with a value
                return Array.isArray(arr) && arr.some(item => item && (item.min || item.max || item.avg));
              });
              this.getChart(this.energyData);
              this.spinner.hide();
              this.showenergyload = false;

              this.energyDatas = this.energyData && Object.keys(this.energyData).length > 0;
            } else {
              this.spinner.hide();
              this.showenergyload = false;
              this.energyDatas = false;
              this.energyData = {};
              this.energyData = {};
              const energyTable = this.energyData.hourlyData;
              const chartsConfig = [
                { unit: "V", key: "voltage", title: "Voltage (V)", series: ["voltageR", "voltageY", "voltageB"] },
                { unit: "A", key: "current", title: "Current (A)", series: ["currentR", "currentY", "currentB"] },
                { unit: "pf", key: "powerfactor", title: "Powerfactor", series: ["powerfactorR", "powerfactorY", "powerfactorB"] },
              ];

              // Loop through each chart
              chartsConfig.forEach(cfg => {
                // Filter only series that have data
                const filteredSeries = cfg.series.filter(seriesKey => {
                  // const actualKey = seriesKey.replace("powerfactor", "powerFactor");
                  return energyTable[seriesKey] && energyTable[seriesKey].length > 0;
                });

                // If no valid data → show “No Data Available”
                if (filteredSeries.length === 0) {
                  this.generateChart(null, cfg.key, cfg.title, cfg.series, cfg.unit);
                } else {
                  // Else → pass data and valid series
                  this.generateChart(this.energyData, cfg.key, cfg.title, filteredSeries, cfg.unit);
                }
              });
              this.getChart(null);
            }
          },
          (error) => {
            console.error('Error fetching energy metrics:', error);
            this.spinner.hide();
            this.showenergyload = false;
            this.energyDatas = false;
            this.energyData = {};
            this.getChart(null);
            this.energyData = {};
            const energyTable = this.energyData.hourlyData;
            const chartsConfig = [
              { unit: "V", key: "voltage", title: "Voltage (V)", series: ["voltageR", "voltageY", "voltageB"] },
              { unit: "A", key: "current", title: "Current (A)", series: ["currentR", "currentY", "currentB"] },
              { unit: "pf", key: "powerfactor", title: "Powerfactor", series: ["powerfactorR", "powerfactorY", "powerfactorB"] },
            ];

            // Loop through each chart
            chartsConfig.forEach(cfg => {
              // Filter only series that have data
              const filteredSeries = cfg.series.filter(seriesKey => {
                // const actualKey = seriesKey.replace("powerfactor", "powerFactor");
                return energyTable[seriesKey] && energyTable[seriesKey].length > 0;
              });

              // If no valid data → show “No Data Available”
              if (filteredSeries.length === 0) {
                this.generateChart(null, cfg.key, cfg.title, cfg.series, cfg.unit);
              } else {
                // Else → pass data and valid series
                this.generateChart(this.energyData, cfg.key, cfg.title, filteredSeries, cfg.unit);
              }
            });

          }
        );

    }
  }

  formatKey(key: string): string {
    // Split camelCase into words
    return key.replace(/([a-z])([A-Z])/g, '$1 $2') // currentB → current B
      .replace(/^./, str => str.toUpperCase()); // capitalize first letter
  }

  getChart(data) {
    if (
      !data ||
      data["hourlyData"].length === 0 ||
      !Array.isArray(data["hourlyData"]["Labels"]) ||
      !Array.isArray(data["hourlyData"]["Energy"]) ||
      data["hourlyData"]["Labels"].length === 0 ||
      data["hourlyData"]["Energy"].length !==
      data["hourlyData"]["Labels"].length
    ) {
      this.energyChartOption = {
        title: {
          text: "No Data Available",
          left: "center",
          top: "middle",
          textStyle: {
            color: "#999",
            fontSize: 16,
            fontWeight: "bold",
          },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }
    this.energyChartOption = {
      title: {
        text: "Total Energy (kWh)",
        left: "start",
        textStyle: {
          color: "#000000ff",
          fontSize: 16,
          fontWeight: "bold",
        },
      },
      legend: {
        top: -5,
        data: ["Energy"],
      },
      grid: {
        top: "15%",
        left: "5%",
        right: "5%",
        bottom: "10%",
        containLabel: true,
      },
      dataZoom: [
        {
          type: "inside",
          xAxisIndex: 0,
          start: 0,
          end: 100,
        },
      ],
      tooltip: {
        trigger: "axis",
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: {
          color: "#333",
          fontSize: 12,
        },
        formatter: function (params) {
          const item = params[0];
          return `${item.axisValue}<br/>${item.seriesName}: ${item.data} kWh`;
        },
      },

      xAxis: {
        name: "Hours",
        nameLocation: "middle",
        nameGap: 20,
        nameTextStyle: {
          fontWeight: "bold",
          fontSize: 10,
        },
        type: "category",
        data: data["hourlyData"]["Labels"],
        axisLabel: {
          rotate: 0,
          fontSize: 9,

          // formatter: function (value) {
          //   return value.split("-")[1];
          // },
        },
      },
      yAxis: {
        name: "kWh",
        nameLocation: "middle",
        nameGap: 40,
        nameTextStyle: {
          fontWeight: "bold",
          fontSize: 10,
        },
        type: "value",
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
      series: [
        {
          name: "Energy",
          type: "bar",
          data: data["hourlyData"]["Energy"],
          smooth: false,
          color:'#6CA651',
          label: {
            show: true,
            position: "top",
            color: "#000",
            fontWeight: "bold",
            formatter: function (params) {
              return params.value === 0 ? "" : `${params.value}`;
            },
          },
        },
      ],
    };
  }
  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }
  generateChart(data, key, title, seriesKeys, unit) {
    const hourlyData = data?.hourlyData || {};
    if (
      !data ||
      !hourlyData ||
      !Array.isArray(hourlyData.parameterLabels) ||
      hourlyData.parameterLabels.length === 0 ||
      seriesKeys.some(s => !Array.isArray(hourlyData[s]))
    ) {
      console.log(key, "keycame heere")
      this[`${key}ChartOption`] = {
        title: { text: "No Data Available", left: "center", top: "middle", textStyle: { color: "#999", fontSize: 16, fontWeight: "bold" } },
        xAxis: { show: false },
        yAxis: { show: false },
        series: []
      };
      return;
    }
    console.log("came heere2")
    const stats = arr => {
      const min = Math.min(...arr);
      const max = Math.max(...arr);
      const avg = (arr.reduce((a, b) => a + b, 0) / arr.length).toFixed(2);
      return { min, max, avg };
    };

    this[`${key}ChartOption`] = {
      title: { text: title, left: "start", textStyle: { color: "#000", fontSize: 16, fontWeight: "bold" } },
      legend: { top: -5, data: seriesKeys },
      grid: { top: "15%", left: "5%", right: "5%", bottom: "10%", containLabel: true },
      dataZoom: [{ type: "inside", xAxisIndex: 0, start: 0, end: 100 }],
      tooltip: {
        trigger: "axis",
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: { color: "#333", fontSize: 12 },
        formatter: function (params) {
          const hour = params[0]?.axisValue ?? "-";
          const visibleSeries = params.map(p => p.seriesName);

          // Build a quick lookup of current visible values
          const values = {};
          params.forEach(p => (values[p.seriesName] = p.data));

          // Compute stats only for visible series
          const statsMap = {};
          visibleSeries.forEach(s => {
            const dataArr = hourlyData[s];
            if (Array.isArray(dataArr) && dataArr.length > 0) {
              const min = Math.min(...dataArr);
              const max = Math.max(...dataArr);
              const avg = (dataArr.reduce((a, b) => a + b, 0) / dataArr.length).toFixed(2);
              statsMap[s] = { min, max, avg };
            } else {
              statsMap[s] = { min: "-", max: "-", avg: "-" };
            }
          });

          return `
      <b>Hour:</b> ${hour} <br/>
      ${visibleSeries
              .map(
                s =>
                  `<b>${s}:</b> ${values[s]} (Min: ${statsMap[s].min}, Max: ${statsMap[s].max}, Avg: ${statsMap[s].avg})`
              )
              .join("<br/>")}
    `;
        }
      },
      xAxis: {
        name: "Hours",
        nameLocation: "middle",
        nameGap: 25,
        nameTextStyle: { fontWeight: "bold", fontSize: 10 },
        type: "category",
        data: hourlyData.parameterLabels,
        axisLabel: {
          rotate: 0,
          fontSize: 10,
          interval: "auto" // <-- ECharts automatically limits labels like yAxis
        }
      },

      yAxis: {
        name: unit,
        nameLocation: "middle",
        nameGap: 40,
        nameTextStyle: { fontWeight: "bold", fontSize: 10 },
        type: "value",
        axisTick: { show: false },
        splitLine: { show: false }
      },
      series: seriesKeys.map(s => ({
        name: s,
        type: "line",
        data: hourlyData[s],
        smooth: false,
        // label: { show: true, position: "top", color: "#000", fontWeight: "bold", formatter: p => p.value === 0 ? "" : `${p.value}` }
      }))
    };
  }
  pdf() {
    this.pdfBool = true;
    this.csvBool = false;
  }
  csv() {
    this.csvBool = true;
    this.pdfBool = false;
  }
  get email() {
    return this.mailform.get("email");
  }
  mailexport() {
    this.pdfBool = false;
    this.csvBool = false;
    this.exportViaMail = true;
  }
  directExpo() {
    this.exportViaMail = false;
    this.pdfBool = false;
    this.csvBool = false;
    this.mailform.reset();
  }
  isEmailInvalid() {
    return this.email.invalid && (this.email.dirty || this.email.touched);
  }
  openModal(templatepdf: any, data: any, act: any) {
    this.action = act;
    this.modalService.open(templatepdf, { centered: true });
  }
  cancel() {
    this.pdfBool = false;
    this.csvBool = false;
    this.mailform.reset();
    this.exportViaMail = false;
  }
  chartInstance: any;
  voltchartInstance: any;
  curchartInstance: any;
  pfchartInstance: any;


  onChartInit(ec: any) {
    this.chartInstance = ec;
  }
  onvoltChartInit(ec: any) {
    this.voltchartInstance = ec;
  }
  oncurChartInit(ec: any) {
    this.curchartInstance = ec;
  }
  onpfChartInit(ec: any) {
    this.pfchartInstance = ec;
  }
  generateParameterTable(tableData: any, prefix: string) {
    if (!tableData) return null;

    let unit = "";
    let displayPrefix = "";

    if (prefix === "current") {
      unit = "A";
      displayPrefix = "Current";
    } else if (prefix === "voltage") {
      unit = "V";
      displayPrefix = "Voltage";
    } else if (prefix === "powerFactor") {
      unit = "pf";
      displayPrefix = "Power Factor";
    }

    const headers = [
      "Parameter",
      `Minimum Value (${unit})`,
      "Minimum Occurrence Time",
      `Maximum Value (${unit})`,
      "Maximum Occurrence Time",
      `Average Value (${unit})`,
    ];

    const body: any[] = [
      headers.map(h => ({ text: h, fillColor: "#007d79", color: "#fff", bold: true }))
    ];

    for (const [key, value] of Object.entries(tableData)) {
      if (!key.startsWith(prefix)) continue;

      const arr = value as Array<Record<string, any>>;
      // 🧹 Skip empty arrays
      if (!Array.isArray(arr) || arr.length === 0) continue;

      const minObj = arr.find(item => item.min !== undefined);
      const maxObj = arr.find(item => item.max !== undefined);
      const avgObj = arr.find(item => item.avg !== undefined);

      // 🧹 Skip if all min/max/avg are missing
      if (!minObj && !maxObj && !avgObj) continue;

      const min = minObj?.min ?? "-";
      const minTs = minObj?.ts ?? "-";
      const max = maxObj?.max ?? "-";
      const maxTs = maxObj?.ts ?? "-";
      const avg = avgObj?.avg ?? "-";

      const suffix = key.replace(prefix, "").toUpperCase();
      const displayName = `${displayPrefix} ${suffix}`.trim();

      body.push([
        { text: displayName, bold: true },
        `${min}`,
        minTs,
        `${max}`,
        maxTs,
        `${avg}`,
      ]);
    }

    // 🧹 If no valid rows (only header), skip table
    if (body.length === 1) return null;

    return {
      table: {
        headerRows: 1,
        widths: ["*", "*", "*", "*", "*", "*"],
        body: body,
      },
      layout: {
        fillColor: (rowIndex: number) => {
          if (rowIndex === 0) return "#9ef0f0";
          return rowIndex % 2 === 0 ? "#d9fbfb" : "#fafafa";
        },
        hLineWidth: () => 0.3,
        vLineWidth: () => 0.3,
      },
      fontSize: 9,
      margin: [0, 5, 0, 20],
    };
  }

  download() {
    if (!this.pdfBool && !this.csvBool) this.pdfBool = true;
    let totalEnergy = this.energyData?.energyData?.total_energy || 0
    let total_realPower = this.energyData?.energyData?.total_realPower || 0
    let total_apparentPower = this.energyData?.energyData?.total_apparentPower || 0
    let total_reactivePower = this.energyData?.energyData?.total_reactivePower || 0
    let total_energyCost = this.energyData?.energyData?.total_energyCost || 0
    let currency = this.energyData?.energyData?.currency || '₹'


    if (
      this.pdfBool &&
      this.base64String !== undefined &&
      !this.exportViaMail
    ) {

      const reportDate = moment(this.fromDate).format("YYYY-MM-DD");
      const pdfFileName = `Energy Summary Report ${reportDate}`;
      const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");
      const currentYear = moment().format("YYYY");

      const chartImage = this.chartInstance?.getDataURL({
        type: "png",
        pixelRatio: 2,
        backgroundColor: "#fff",
      });

      const voltageChartImage = this.voltchartInstance?.getDataURL({
        type: "png",
        pixelRatio: 2,
        backgroundColor: "#fff",
      });

      const currentChartImage = this.curchartInstance?.getDataURL({
        type: "png",
        pixelRatio: 2,
        backgroundColor: "#fff",
      });

      const powerFactorChartImage = this.pfchartInstance?.getDataURL({
        type: "png",
        pixelRatio: 2,
        backgroundColor: "#fff",
      });

      const pdfContent: any[] = [
        {
          columns: [
            {
              image: `${this.base64String}`,
              width: 140,
              height: 45,
              alignment: "left",
              margin: [-30, -28, 0, 0],
            },
          ],
        },
        {
          columns: [
            {
              text: "ENERGY REPORT",
              fontSize: 15,
              bold: true,
              alignment: "center",
              margin: [0, -35, 0, 0],
            },
          ],
        },
        {
          columns: [
            {
              text: "(Date :  " + this.fromDate + ")",
              margin: [0, -10, 0, 0],
              fontSize: 10,
              bold: true,
              alignment: "center",
            },
          ],
        },
        {
          canvas: [
            {
              type: "line",
              lineColor: "#007d79",
              x1: -40,
              y1: 0,
              x2: 800,
              y2: 0,
              lineWidth: 0.8,
            },
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: "Department : " + this.selectedDepartment,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 6],
        },
        {
          text: "Shift : " + this.selectedShift,
          fontSize: 12,
          bold: true,
          margin: [0, 5, 0, 6],
        },
        {
          text: "Machine Name : " + this.selectedMachine,
          fontSize: 12,
          bold: true,
          margin: [0, 5, 0, 6],
        },
        {
          text: `Energy Cost: ${total_energyCost} ${currency}`,
          fontSize: 12,
          bold: true,
          margin: [0, 5, 0, 6],
        }
      ];
      if (chartImage) {
        pdfContent.push(
          { text: "Hourly Energy Consumption", fontSize: 13, bold: true, margin: [0, 60, 0, 8] },
          { image: chartImage, width: 720, alignment: "center", margin: [0, 5, 0, 20] }
        );
      }
      const totalSummaryTable = [
        [
          { text: "Total Energy (kWh)", bold: true, fillColor: "#007d79", color: "#fff" },
          { text: "Total Real Power (W)", bold: true, fillColor: "#007d79", color: "#fff" },
          { text: "Total Apparent Power (VA)", bold: true, fillColor: "#007d79", color: "#fff" },
          { text: "Total Reactive Power (VAR)", bold: true, fillColor: "#007d79", color: "#fff" },
        ],
        [
          totalEnergy.toString(),
          total_realPower?.toString() ?? "-",
          total_apparentPower?.toString() ?? "-",
          total_reactivePower?.toString() ?? "-",
        ],
      ];

      pdfContent.push(
        { text: "Total Summary", fontSize: 13, bold: true, margin: [0, 10, 0, 8] },
        {
          table: {
            headerRows: 1,
            widths: ["*", "*", "*", "*"],
            body: totalSummaryTable,
          },
          layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? "#007d79" : "#fafafa"),
            hLineWidth: () => 0.3,
            vLineWidth: () => 0.3,
          },
          fontSize: 10,
          margin: [0, 0, 0, 20],
        }
      );
      if (voltageChartImage) {
        pdfContent.push(
          { text: "Voltage Consumption", fontSize: 13, bold: true, margin: [0, 90, 0, 8] },
          { image: voltageChartImage, width: 720, alignment: "center", margin: [0, 5, 0, 10] }
        );
      }
      if (!voltageChartImage) {
        pdfContent.push(
          { text: "Voltage Consumption", fontSize: 13, bold: true, margin: [0, 90, 0, 8] });
      }
      const voltageTable = this.generateParameterTable(this.energyData?.tableData, "voltage");
      if (voltageTable) pdfContent.push(voltageTable);

      if (currentChartImage) {
        pdfContent.push(
          { text: "Current Consumption", fontSize: 13, bold: true, margin: [0, 50, 0, 8] },
          { image: currentChartImage, width: 720, alignment: "center", margin: [0, 5, 0, 10] }
        );
      }
      if (!currentChartImage) {
        pdfContent.push(
          { text: "Current Consumption", fontSize: 13, bold: true, margin: [0, 20, 0, 8] });
      }

      const currentTable = this.generateParameterTable(this.energyData?.tableData, "current");
      if (currentTable) pdfContent.push(currentTable);

      if (powerFactorChartImage) {
        pdfContent.push(
          { text: "Power Factor Consumption", fontSize: 13, bold: true, margin: [0, 70, 0, 8] },
          { image: powerFactorChartImage, width: 720, alignment: "center", margin: [0, 5, 0, 10] }
        );
      }
      if (!powerFactorChartImage) {
        pdfContent.push(
          { text: "Power Factor Consumption", fontSize: 13, bold: true, margin: [0, 40, 0, 8] });
      }

      const pfTable = this.generateParameterTable(this.energyData?.tableData, "powerFactor");
      if (pfTable) pdfContent.push(pfTable);

      const pdfDefinition = {
        pageSize: "A4",
        pageOrientation: "landscape",
        pageMargins: [40, 40, 40, 30],

        header: () => ({
          text: currentDateTime,
          alignment: "right",
          margin: [0, 10, 20, 0],
          fontSize: 9,
        }),

        footer: (currentPage, pageCount) => [
          {
            text: `Page ${currentPage} of ${pageCount}`,
            alignment: "center",
            fontSize: 8,
          },
          {
            text: `© ${currentYear} Wimera Systems Pvt Ltd`,
            alignment: "right",
            fontSize: 8,
            margin: [5, 2, 10, 10],
          },
        ],
        content: pdfContent,
      };
      pdfMake.createPdf(pdfDefinition).download(`${pdfFileName}.pdf`);
    }
    else if (this.csvBool && !this.exportViaMail) {
      const csvRows: string[] = [];
      const formatTime = (ts: string | number | undefined) => {
        return ts ? moment(ts).format("YYYY-MM-DD HH:mm:ss.S") : "-";
      };

      // ===== Report Header =====
      csvRows.push(`ENERGY REPORT`);
      csvRows.push(`Date:,${moment(this.fromDate).format("YYYY-MM-DD")}`);
      csvRows.push(`Department:,${this.selectedDepartment}`);
      csvRows.push(`Shift:,${this.selectedShift}`);
      csvRows.push(`Machine Name:,${this.selectedMachine}`);

      const currencySymbol = currency || "₹";
      csvRows.push(`Energy Cost:,${currencySymbol}${total_energyCost.toFixed(2)}`);
      csvRows.push(""); // empty line

      // ===== Total Summary =====
      csvRows.push("Total Summary");
      csvRows.push(
        "Total Energy (kWh),Total Real Power (W),Total Apparent Power (VA),Total Reactive Power (VAR)"
      );
      csvRows.push(
        `${totalEnergy},${total_realPower ?? "-"},${total_apparentPower ?? "-"},${total_reactivePower ?? "-"}`
      );
      csvRows.push(""); // empty line

      // ===== Parameter Tables (Voltage, Current, Power Factor) =====
      const tableData = this.energyData?.tableData || {};

      const parameterGroups = [
        { prefix: "voltage", display: "Voltage", unit: "V" },
        { prefix: "current", display: "Current", unit: "A" },
        { prefix: "powerFactor", display: "Power Factor", unit: "pf" },
      ];

      for (const group of parameterGroups) {
        const { prefix, display, unit } = group;

        // ✅ Get only keys with data (non-empty arrays)
        const validKeys = Object.keys(tableData).filter(k => {
          if (!k.startsWith(prefix)) return false;
          const arr = tableData[k];
          return Array.isArray(arr) && arr.length > 0;
        });

        if (validKeys.length === 0) continue; // skip if no valid data

        csvRows.push(`${display} Summary`);
        csvRows.push(`Parameter,Minimum Value (${unit}),Minimum Occurrence Time,Maximum Value (${unit}),Maximum Occurrence Time,Average Value (${unit})`);

        for (const key of validKeys) {
          const arr = tableData[key] as Array<Record<string, any>>;
          if (!arr || arr.length === 0) continue;

          const minObj = arr.find(item => item.min !== undefined);
          const maxObj = arr.find(item => item.max !== undefined);
          const avgObj = arr.find(item => item.avg !== undefined);

          // ✅ Skip rows that have no values at all
          if (!minObj && !maxObj && !avgObj) continue;

          const min = minObj?.min ?? "-";
          const minTs = formatTime(minObj?.ts);
          const max = maxObj?.max ?? "-";
          const maxTs = formatTime(maxObj?.ts);
          const avg = avgObj?.avg ?? "-";

          // Beautify parameter name (e.g., voltageB → Voltage B)
          const suffix = key.replace(prefix, "").toUpperCase();
          const displayName = `${display} ${suffix}`.trim();

          csvRows.push(`${displayName},${min},${minTs},${max},${maxTs},${avg}`);
        }

        csvRows.push(""); // empty line between tables
      }

      // ===== CSV Export Logic =====
      const csvContent = "\uFEFF" + csvRows.join("\n");
      const startDate = moment(this.fromDate).format("YYYY-MM-DD");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Energy_Report_${startDate}.csv`;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);


    }
    else if (this.pdfBool && this.exportViaMail) {
      const chartImage = this.chartInstance?.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      });
      let data = this.mailform.value;
      let maildata = {};
      (maildata["to"] = data["email"]),
        (maildata["reportname"] = "energyReports"),
        (maildata["fromDate"] = this.fromDate),
        (maildata["departmentName"] = this.selectedDepartment),
        (maildata["machineName"] = this.selectedMachine),
        (maildata["shiftName"] = this.selectedShift),
        (maildata["energyData"] = this.energyData?.energyData),
        (maildata["tableData"] = this.energyData?.tableData),
        (maildata["imageUrl"] = chartImage),
        (maildata["customerName"] = this.custName),
        (maildata["hourlylableData"] = this.energyData?.hourlyData?.['Labels']),
        (maildata["hourlyEnergyData"] = this.energyData?.hourlyData?.['Energy']),
        (maildata["filetype"] = "pdf");
      this.toastr.info("please wait while processing");
      this.dataService.post("api/sendMail", maildata).subscribe(
        (res) => {
          this.toastr.success("Mail sent successfully!");
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
    } else if (this.csvBool && this.exportViaMail) {
      let data = this.mailform.value;
      let maildata = {};
      (maildata["to"] = data["email"]),
        (maildata["reportname"] = "energyReports"),
        (maildata["fromDate"] = this.fromDate),
        (maildata["energyData"] = this.energyData?.energyData),
        (maildata["tableData"] = this.energyData?.tableData),
        (maildata["hourlylableData"] = this.energyData?.hourlyData?.['Labels']),
        (maildata["hourlyEnergyData"] = this.energyData?.hourlyData?.['Energy']),
        (maildata["departmentName"] = this.selectedDepartment),
        (maildata["customerName"] = this.custName),
        (maildata["machineName"] = this.selectedMachine),
        (maildata["shiftName"] = this.selectedShift),
        (maildata["filetype"] = "csv");
      this.toastr.info("please wait while processing");
      this.dataService.post("api/sendMail", maildata).subscribe(
        (res) => {
          this.toastr.success("Mail sent successfully!");
        },
        (err) => {
          this.toastr.error(err.message);
        }
      );
    }
    this.pdfBool = false;
    this.csvBool = false;
    this.exportViaMail = false;
    this.mailform.reset();
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
